module.exports = __webpack_public_path__ + "img/resort-05.4812f511.jpg";